<template>
<div class="app-container">
  <div style="margin-bottom:10px;display: flex;justify-content: space-between;">
    <div>
      <el-input size="mini" placeholder="公司名称" v-model="listQuery.name" style="width:150px" @keyup.enter="getList"></el-input>
      <el-button size="mini" type="primary" @click="getList" style="margin-right:10px">搜索</el-button>
      <search @success="getList">
        <el-form style="margin:21px 0px 0px 6px;height:150px;width:700px" class="styleForm">
          <el-form-item label="纳税人类型 ：" :label-width="formLabelWidth">
            <selecttaxtype v-model:type="listQuery.type"></selecttaxtype>
          </el-form-item>
          <el-form-item label="采集状态 ：" :label-width="formLabelWidth"> 
            <selectCollectStatus v-model:collectStatus="listQuery.setUpStatusCj"></selectCollectStatus>
          </el-form-item>
        </el-form>
      </search>
    </div>
    <div>
      <el-button @click="handleCateg()" size="mini" type="primary">更新税种</el-button> 
      <el-button @click="handleTaxTable()" size="mini" type="warning">重新采集税表</el-button> 
    </div>
  </div>
  <el-table stripe :data="list" :height="contentStyleObj" style="width: 100%" v-loading="loading" border size="mini" @selection-change="handleSelectionChange" >
    <el-table-column align="center" prop="id" type="selection" min-width="55" />
    <el-table-column align="center" fixed type="index" label="编号" width="55" />
    <el-table-column prop="name" fixed label="公司名称" min-width="280" >
      <template #default="scope">
        <span v-if="scope.row.type == '1'" class="xgmStyle">小</span>
        <span v-if="scope.row.type == '2'" class="ybStyle">般</span>
        <span type="text">{{ scope.row.name }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" prop="startAccountPeriod" label="启用账期" min-width="100">
      <template #default="scope">
        <span>{{ scope.row.startAccountPeriod }}</span>  
      </template>
    </el-table-column>
    <el-table-column align="center" prop="accountSystem" label="会计制度" width="170">
      <template #default="scope">
        <span>{{ scope.row.accountSystem }}</span>  
      </template>
    </el-table-column>
    <el-table-column align="center" prop="accountSystem" label="初始化来源" min-width="130">
      <template #default="scope">
        <div class="item_icon">
          <i v-if="scope.row.init.tax_category_methon == '已采集'" class="el-icon-success"></i>
          <i v-if="scope.row.init.tax_category_methon == '跳过采集'" class="el-icon-info"></i>
          <i v-if="scope.row.init.tax_category_methon == '采集中'" class="el-icon-info"></i>
          <i v-if="scope.row.init.tax_category_methon == '未采集'" class="el-icon-warning"></i>
          <i v-if="scope.row.init.tax_category_methon == '采集失败'" class="el-icon-error"></i>
        </div>
        <el-tooltip class="item" effect="dark" :content="scope.row.FailReason" placement="top-start">
          <el-button size="mini" class="sbcg" style="border: 0;">{{scope.row.init.tax_category_methon}}</el-button>
        </el-tooltip>
        <span>{{  }}</span>  
      </template>
    </el-table-column>
    <el-table-column label="税务报表初始化状态" header-align='center'>
      <el-table-column prop="init" label="增值税" align="center">
        <template #default="scope">
          <div class="item_icon" v-if="scope.row.init.tax_zzs == 1">
            <i class="el-icon-success"></i>
          </div>
          <div class="item_icon" v-else>
            <i class="el-icon-error"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="所得税" prop="init" align="center">
        <template #default="scope">
           <div class="item_icon" v-if="scope.row.init.tax_sds == 1">
            <i class="el-icon-success"></i>
          </div>
          <div class="item_icon" v-else>
            <i class="el-icon-error"></i>
          </div>
        </template>
      </el-table-column>
    </el-table-column>
    <el-table-column align="center" prop="ndks" label="弥补亏损" min-width="80">
      <template #default="scope">
        <span @click="annualLoss(scope.row.id)" style="cursor:pointer;color:#39b0d2;text-decoration:underline">{{ scope.row.init.ndks }}</span>
      </template>
    </el-table-column>
    <el-table-column label="财报报表初始化状态" header-align='center'>
      <el-table-column prop="endCount" label="资产负债表" align="center">
        <template #default="scope">
          <div class="item_icon" v-if="scope.row.init.kj_zcfz == 1">
            <i class="el-icon-success"></i>
          </div>
          <div class="item_icon" v-else>
            <i class="el-icon-error"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="利润表" prop="init" align="center">
        <template #default="scope">
          <div class="item_icon" v-if="scope.row.init.kj_lrb == 1">
            <i class="el-icon-success"></i>
          </div>
          <div class="item_icon" v-else>
            <i class="el-icon-error"></i>
          </div>
        </template>
      </el-table-column>
    </el-table-column>
    <el-table-column label="建账初始化状态" header-align='center'>
      <el-table-column prop="endCount" label="余额表上传" align="center" min-width="120px">
        <template #default="scope">
          <div class="item_icon" v-if="scope.row.init.subject >= 2" style="width:100%">
            <i class="el-icon-success"></i>
            {{scope.row.init.subject_methon}}
          </div>
          <div class="item_icon" v-else>
            <i class="el-icon-error"></i>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="init" label="建账来源" align="center">
        <template #default="scope">
          <span v-if="scope.row.init.subject >= 2">{{scope.row.init.subject_methon}}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="科目匹配" prop="init" align="center">
        <template #default="scope">
          <div class="item_icon" v-if="scope.row.init.subject >= 3">
            <i class="el-icon-success"></i>
          </div>
          <div class="item_icon" v-else>
            <i class="el-icon-error"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="endAmount" label="数据确认" align="center">
        <template #default="scope">
          <div class="item_icon" v-if="scope.row.init.subject >= 4">
            <i class="el-icon-success"></i>
          </div>
          <div class="item_icon" v-else>
            <i class="el-icon-error"></i>
          </div>
        </template>
      </el-table-column>
    </el-table-column>
    <el-table-column align="center" prop="address" label="操作" min-width="100">
      <template #default="scope">
        <el-button @click="handleUpdate(scope.row)" size="mini" type="text">查看</el-button>
        <!-- todo -->
      </template>
    </el-table-column>
  </el-table>
  <div class="pagination">
    <qzf-pagination v-show="userTotal>0" :total="userTotal" v-model:page="listQuery.page" v-model:limit="listQuery.limit" @pagination="getList" />
  </div>

  <el-dialog destroy-on-close v-model="dialogVisible" title="初始化报表" width="60%" :before-close="handleClose">
    <el-table :data="list2" border height="400px" style="margin-bottom:10px">
      <el-table-column align="left" prop="tableName" label="申报列表名称" min-width="240">
        <template #default="scope">
          <span type="text">{{ $tableNameFilter(scope.row.tableName) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="period" label="税款所属期" min-width="150" >
        <template #default="scope">
          <span type="text">{{ scope.row.period }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="name" label="初始化状态" min-width="150" >
        <template #default="scope">
          <span type="text">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="name" label="操作" min-width="180" class-name="top_right_btns">
        <template #default="scope">
          <el-tooltip content="查看" placement="top">
            <i class="el-icon-view" @click="editTax(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="dialogVisible = false">确定</el-button>
      </span>
    </template>
  </el-dialog>
</div>
  <annualLossCom ref="annualLossCom" @success="getList"></annualLossCom>
</template>

<script>
import { eaCompanyList } from "@/api/company"
import { getInitTax } from "@/api/taxCalculation"
import annualLossCom from "./annualLossCom.vue"
import selectCollectStatus from "@/components/Screening/selectCollectStatus";
import selecttaxtype from "@/components/Screening/selecttaxtype";
import { currentAccountPeriod } from '@/utils'
import { sendTask } from "@/api/collection"
import loginVue from '../../login/login.vue'
export default {
  name:'initTable',
  components:{
    annualLossCom,
    selectCollectStatus,
    selecttaxtype
  },
  created(){
    this.getList()
    this.contentStyleObj= this.$getHeight(290)
    this.initBus()
  },
  data() {
    return {
      list:[],
      list2:[],
      userTotal:0,
      dialogVisible:false,
      accountSystem:'',
      startAccountPeriod:'',
      comId:0,
      qysdsType:0,
      listQuery:{
        page:1,
        limit:20,
        from:'init',
        name:''
      },
      loading:false,
      formLabelWidth:'100px',
      gsMainIds: undefined,
      initTaxNo:'',
      initName:''
    }
  },
  methods:{
    initBus(){
      this.$bus.on("refreshTask", () => {
        //刷新业务
        let status = false
        this.list.forEach(res => {
          if(res.init.tax_category_methon == '采集中') {
            status = true
          }
        })
        if(status == true) {
          this.getList()
        }
      });
    },
    getList(){
      this.loading = true
      eaCompanyList(this.listQuery).then(res=>{
        this.loading = false
        this.list = res.data.data.list
        this.userTotal = res.data.data.total
      })
    },
    handleUpdate(row){
      this.initTaxNo = row.taxNo
      this.initName = row.name
      this.accountSystem = row.accountSystem
      this.comId = row.id
      this.qysdsType = row.qysdsStatus
      getInitTax({comId:row.id}).then(res=>{
        this.list2 = res.data.data.list 
        this.dialogVisible = true
      })
    },
    handleSelectionChange(row) {
      this.gsMainIds = []
      row.map(info=>{
        this.gsMainIds.push(info.id)
      })
    },
    //更新税种
    handleCateg() {
      if(!this.gsMainIds){
        this.$qzfMessage("请选择公司", 1)
        return
      }
      let param = {
        taskName: 'tax-cj-taxCategory',
        comIds: this.gsMainIds
      }
      sendTask(param).then(res => {
        if(res.data.msg == 'success') {
          this.$qzfMessage('采集任务已发起',3)
          this.getList()
        }
      })
    },
    //重新采集税表
    handleTaxTable() {
      if(!this.gsMainIds){
        this.$qzfMessage("请选择公司", 1)
        return
      }
      let param = {
        taskName: 'tax-cj-resetTaxs',
        comIds: this.gsMainIds,
      }
      sendTask(param).then(res => {
        if(res.data.msg == 'success') {
         this.$qzfMessage('采集任务已发起',3)
          this.getList()
        }
      })
    },
    editTax(row){
      console.log(row);
      this.startAccountPeriod = row.period
      this.$store.dispatch("commons/setParam", {type: this.accountSystem})
      this.$store.dispatch("commons/setParam", {startAccountPeriod: this.startAccountPeriod})
      this.$store.dispatch("commons/setParam", {comId: this.comId})
      this.$store.dispatch("commons/setParam", {qysdsType: this.qysdsType})
      this.$store.dispatch("commons/setParam", {tableName: row.tableName})
      this.$store.dispatch("commons/setParam", {initTaxNo: this.initTaxNo})
      this.$store.dispatch("commons/setParam", {initName: this.initName})

      if(row.tableName == 'kj_lrb'|| row.tableName == 'kj_zcfz'|| row.tableName == 'kj_xjllb'){
          this.$router.push({
          path: "/initEa/kjInitTable",   //会计报表  ok
        });
      }else if(row.tableName == 'gs_vat'){
          this.$router.push({
          path: "/initEa/initVatInvoice",   //增值税报表 一般纳税人  ok
        });
      }else if(row.tableName == 'gs_small_vat'){
          this.$router.push({
          path: "/initEa/initSmallVat",   //增值税报表 小规模  ok
        });
      }else if(row.tableName == 'gs_tax_quarter'){
          this.$router.push({
          path: "/initEa/initQysds",   //企业所得税
        });
      }else if(row.tableName == 'gs_deed'){
          this.$router.push({
          path: "/initEa/initPropertyTax",   //财产和行为纳税申报表
        });
      }else if(row.tableName == 'gs_qtsr'){
          this.$router.push({
          path: "/initEa/initTaxNeimengQtsr",   //其他收入(工会经费)
        });
      }else if(row.tableName == 'gs_sl'){
          this.$router.push({
          path: "/initEa/initTaxNeimengSl",   //水利建设专项收入
        });
      }else if(row.tableName == 'gs_ljcl'){
          this.$router.push({
          path: "/initEa/initTaxCityLife",   //城市生活垃圾处置费
        });
      }else if(row.tableName == 'gs_xfs'){
          this.$router.push({
          path: "/initEa/initXfs",   //消费费
        });
      }else if(row.tableName == 'gs_cbj'){
          this.$router.push({
          path: "/initEa/initCbj",   //残疾人就业保障金申报表
        });
      }else if(row.tableName == 'gs_whsyjsfsbbygz'){
          this.$router.push({
          path: "/initEa/initCulturalTax",   //文化事业建设费申报表
        });
      }
    },
    annualLoss(id){
      this.$refs.annualLossCom.getListKS(id)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table {
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
  // span {
  //   white-space:nowrap !important;
  //   overflow:hidden !important;
  //   text-overflow:ellipsis !important;
  // }
}

.top_right_btns {
  i{
    margin: 0 5px;
    cursor: pointer;
    color: $color-main;
    font-size: 18px;
    line-height: 24px;
  }
}
.item_icon{
  display: inline-block;
  width: 32%;
  // padding: 1px 3px;
  // padding-right: 10px;
  
  cursor: pointer;
  i{
    display: inline-block;
    line-height: 28px;
    font-size: 16px;
  }
  .el-icon-error{
    color: #f56c6c;
  }
  .el-icon-success{
    color: #67c23a;
  }
  .el-icon-circle-check{
    color: #67c23a;
  }
  .el-icon-info{
    color: #409eff
  }
  .el-icon-warning{
    color: #e6a23c;
  }
  .el-icon-warning-outline{
    color: #e6a23c;
  }
}
.el-select{
  margin-left: 0px;
}
</style>

<style>

</style>